import { Sparkles } from "lucide-react"
import { NavItem } from "@/types/nav"

export const sharedNav: NavItem[] = [
  // TODO: Disabled Ask AI from Navigation
  // {
  //   title: "Ask AI",
  //   url: "/dashboard/ask-ai",
  //   icon: Sparkles,
  // }
] 